/* EF PD2 Sticky ATC — 3-state progressive bar (CRO 2026-04-29)
   - Reads state from 'ef-cfg:state-changed' and 'ef-cfg:price-changed' events
     dispatched by ef-configurator-v2.js (no direct coupling).
   - Mirrors clicks to #efCfgATC (the real Add to Cart button) — single source
     of truth for cart logic, never touches selections{} / surcharges{}.
   - Scoped IDs: #efPd2Sticky*. Does not touch any ef-cfg-* state.
*/
(function () {
  'use strict';

  var sticky      = document.getElementById('efPd2Sticky');
  if (!sticky) return;

  /* Mark body so CSS pads bottom of page (compensates fixed bar) */
  if (document.body) document.body.classList.add('ef-pd2-sticky-active');

  /* Chat killer RESTORED 2026-04-29 evening — theme.liquid lazy-load disabled
     (was breaking MooseDesk init). Now chat loads normally on all pages, and
     this killer removes it from DOM on configurator pages (doors+mantels PDP)
     where the sticky bar already provides Call us as primary support channel.
     CSS file only loads on configurator templates → killer scope is implicit. */
  var _chatSels = [
    '[id^="moosedesk"]', '[class*="moosedesk"]',
    '[id*="moose-chat"]', '[class*="moose-chat"]',
    '[id*="md-chat"]', '[class*="md-chat"]',
    '[data-moosedesk]',
    'iframe[src*="moosedesk"]', 'iframe[src*="moose-chat"]',
    '#ef-mdesk-stub',
    '.shopify-online-store-chat', '#shopify-online-store-chat', '#ShopifyChat',
    '[data-shopify-chat-button]', '[data-testid="chat-button"]',
    'iframe[src*="chat.shopify.com"]', 'iframe[src*="shopifychat"]'
  ];
  function _killChat() {
    _chatSels.forEach(function (sel) {
      try {
        document.querySelectorAll(sel).forEach(function (el) {
          try { el.remove(); }
          catch (_) {
            el.style.setProperty('display', 'none', 'important');
            el.style.setProperty('visibility', 'hidden', 'important');
          }
        });
      } catch (_) {}
    });
  }
  _killChat();
  /* Re-run on ticks — MooseDesk loads async, mounts widget after script ready */
  [200, 500, 1000, 2000, 4000, 8000, 15000].forEach(function (ms) {
    setTimeout(_killChat, ms);
  });
  /* MutationObserver — catches re-injection or late-mount */
  try {
    var _chatObsScheduled = false;
    new MutationObserver(function (muts) {
      /* PERF B6 2026-08-07: only an added ELEMENT can ever match _chatSels —
         skip text-only mutation batches (configurator price updates fired 16
         full-document scans per click). Kill result identical. */
      var hasEl = false;
      for (var i = 0; i < muts.length && !hasEl; i++) {
        var a = muts[i].addedNodes;
        for (var j = 0; j < a.length; j++) { if (a[j].nodeType === 1) { hasEl = true; break; } }
      }
      if (!hasEl) return;
      if (_chatObsScheduled) return;
      _chatObsScheduled = true;
      requestAnimationFrame(function () {
        _chatObsScheduled = false;
        _killChat();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (_) {}

  /* ----- Availability badge — Mon-Fri 9-17 PT (America/Los_Angeles) -----
     Open  → green ● Available now
     Closed → muted ○ Back [today/tomorrow/Mon] at 9 AM PT
     Updates on load + every 60s (handles users sitting on the page across
     the hour boundary). Uses Intl.DateTimeFormat for accurate PT regardless
     of user's local timezone. */
  function _efPd2UpdateAvailability() {
    var badges = document.querySelectorAll('.ef-pd2-contact__badge');
    if (!badges.length) return;
    try {
      var fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Los_Angeles',
        weekday: 'long',
        hour: 'numeric',
        hour12: false
      });
      var parts = fmt.formatToParts(new Date());
      var weekday = '';
      var hour = 0;
      parts.forEach(function (p) {
        if (p.type === 'weekday') weekday = p.value;
        if (p.type === 'hour') hour = parseInt(p.value, 10);
      });
      var WEEKDAYS = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
      var dayIdx = WEEKDAYS.indexOf(weekday);
      var isWeekday = dayIdx >= 1 && dayIdx <= 5;
      var isBusinessHour = hour >= 9 && hour < 17;
      var isOpen = isWeekday && isBusinessHour;

      var label;
      if (isOpen) {
        label = 'Available now';
      } else if (dayIdx === 0 || dayIdx === 6) {
        label = 'Back Mon 9 AM PT';
      } else if (dayIdx === 5 && hour >= 17) {
        label = 'Back Mon 9 AM PT';
      } else if (hour < 9) {
        label = 'Back today 9 AM PT';
      } else {
        label = 'Back tomorrow 9 AM PT';
      }

      badges.forEach(function (badge) {
        badge.classList.toggle('ef-pd2-contact__badge--closed', !isOpen);
        var dot = badge.querySelector('.ef-pd2-contact__badge-dot');
        var dotHtml = dot ? dot.outerHTML : '<span class="ef-pd2-contact__badge-dot" aria-hidden="true"></span>';
        badge.innerHTML = dotHtml + label;
      });
    } catch (_) {}
  }
  _efPd2UpdateAvailability();
  setInterval(_efPd2UpdateAvailability, 60000);

  /* Calendly mobile body-lock — fixes the layout-shift bug on doors PDP where
     position:sticky gallery + Calendly popup viewport recalc = page rozjazd.
     Strategy:
       - On Calendly open: save current scrollY, lock body via position:fixed;
         top:-<scrollY>; width:100%. Page is frozen at exact position.
       - On close: restore styles + window.scrollTo(0, scrollY).
     Body class .ef-pd2-calendly-open is toggled (CSS reads it to override
     .ef-pd-gallery position:sticky → static so no viewport-tracking conflict). */
  var _efSavedScrollY = 0, _efBodyStyle = null, _efGallery = null, _efGalleryStyle = null;
  var _efLockProps = ['position', 'top', 'left', 'right', 'width'];
  var _efGalleryBeforeBooking = null;
  document.addEventListener('click', function(e) {
    if (!e.target.closest('[data-efx-calendly], a[href*="calendly.com"]')) return;
    var gallery = document.querySelector('.ef-pd-gallery');
    _efGalleryBeforeBooking = gallery ? { element: gallery, rect: gallery.getBoundingClientRect(), at: Date.now() } : null;
  }, true);
  function _efSaveStyles(el) { return _efLockProps.map(function(p) { return [p, el.style.getPropertyValue(p), el.style.getPropertyPriority(p)]; }); }
  function _efRestoreStyles(el, saved) { if (el && saved) saved.forEach(function(s) { if (s[1]) el.style.setProperty(s[0], s[1], s[2]); else el.style.removeProperty(s[0]); }); }
  function _efLockBody() {
    if (document.body.classList.contains('ef-pd2-calendly-open')) return;
    _efSavedScrollY = window.scrollY || window.pageYOffset || 0;
    _efBodyStyle = _efSaveStyles(document.body);
    // Freeze the visible desktop gallery before body locking changes sticky geometry.
    _efGallery = window.innerWidth >= 1000 ? document.querySelector('.ef-pd-gallery') : null;
    if (_efGallery) {
      var rect = _efGalleryBeforeBooking && _efGalleryBeforeBooking.element === _efGallery && Date.now() - _efGalleryBeforeBooking.at < 5000
        ? _efGalleryBeforeBooking.rect : _efGallery.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < window.innerHeight) {
        _efGalleryStyle = _efSaveStyles(_efGallery);
        _efGallery.style.setProperty('position', 'fixed', 'important');
        _efGallery.style.setProperty('top', rect.top + 'px', 'important');
        _efGallery.style.setProperty('left', rect.left + 'px', 'important');
        _efGallery.style.setProperty('right', 'auto', 'important');
        _efGallery.style.setProperty('width', rect.width + 'px', 'important');
      } else _efGallery = null;
    }
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + _efSavedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.classList.add('ef-pd2-calendly-open');
  }
  function _efUnlockBody() {
    if (!document.body.classList.contains('ef-pd2-calendly-open')) return;
    document.body.classList.remove('ef-pd2-calendly-open');
    _efRestoreStyles(document.body, _efBodyStyle);
    _efRestoreStyles(_efGallery, _efGalleryStyle);
    _efGallery = null; _efGalleryStyle = null; _efBodyStyle = null; _efGalleryBeforeBooking = null;
    window.scrollTo({ top: _efSavedScrollY, left: 0, behavior: 'instant' });
  }
  window.addEventListener('message', function (e) {
    var d = e && e.data;
    if (!d || typeof d !== 'object') return;
    var ev = String(d.event || '');
    if (ev.indexOf('calendly.') !== 0) return;
    if (ev === 'calendly.popup_closed') {
      _efUnlockBody();
    } else if (ev === 'calendly.event_scheduled') {
      /* Hold lock 1.5s so buyer sees confirmation before page jumps */
      setTimeout(_efUnlockBody, 1500);
    } else if (document.querySelector('.calendly-overlay, .calendly-popup')) {
      /* T7-CAL 2026-09-02 — the guard is the fix, not the timing. Calendly emits a late
         calendly.event_type_viewed AFTER the popup is already torn down (measured: overlay
         absent, message still arriving). This branch used to lock the body for ANY calendly.*
         that was not popup_closed, so that straggler re-applied position:fixed and
         .ef-pd2-calendly-open with nothing left to remove them: the page froze scrolled to
         top and the sticky Add-to-cart bar stayed hidden for the rest of the session.
         Reproduced in 2 of 6 gate runs before this guard. Now we only lock while an overlay
         actually exists. */
      _efLockBody();
    }
  });
  /* Also observe for .calendly-overlay element appearing/disappearing — covers
     edge cases where postMessage events don't fire (e.g. inline embed). */
  try {
    var _calendlyObs = new MutationObserver(function () {
      var open = !!document.querySelector('.calendly-overlay, .calendly-popup');
      if (open) _efLockBody();
      else _efUnlockBody();
    });
    _calendlyObs.observe(document.body, { childList: true, subtree: false });
  } catch (_) {}

  var stickyAtc   = document.getElementById('efPd2StickyAtc');
  var atcLock     = sticky.querySelector('.ef-pd2-sticky__atc-lock');
  var atcArrow    = sticky.querySelector('.ef-pd2-sticky__atc-arrow');
  var atcLabel    = sticky.querySelector('.ef-pd2-sticky__atc-label');
  var msg         = document.getElementById('efPd2StickyMsg');
  var dotsWrap    = document.getElementById('efPd2StickyDots');
  var priceFrom   = document.getElementById('efPd2StickyPriceFrom');
  var priceAmount = document.getElementById('efPd2StickyPriceAmount');
  var priceLabel  = document.getElementById('efPd2StickyPriceLabel');
  /* Mirror target — doors PDP uses #efCfgATC, mantels PDP uses #efmSubmit.
     Pick the first one present in DOM. */
  /* §R9-H8 (2026-09-03) — the third surface. The doors PDP mirrors #efCfgATC,
     the mantel PDP mirrors #efmSubmit, and the cfg-simple order form mirrors
     #efOfAtc. Until this line the script reached the `return` below on every
     cfg-simple door and the bar this template already loaded the CSS and the
     JS for did not exist — 26 % of mobile door revenue, 2,700 px of form, and
     no commit control in view for any of it. One line; the markup arrives from
     snippets/efx-order-bar.liquid. */
  var realAtc     = document.getElementById('efCfgATC')
                 || document.getElementById('efmSubmit')
                 || document.getElementById('efOfAtc');

  if (!stickyAtc || !realAtc) return;

  /* Reuse the existing phone control; single-page order bars may not have one. */
  if (!sticky.querySelector('.ef-pd2-sticky__call')) {
    var phone = document.createElement('a');
    phone.className = 'ef-pd2-sticky__call'; phone.href = 'tel:+19496197824';
    phone.setAttribute('aria-label', 'Call ExceptionalFire at (949) 619-7824');
    phone.setAttribute('data-ef-pd2-track', 'call-sticky');
    phone.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/></svg><span class="ef-pd2-sticky__call-desktop">(949) 619-7824</span>';
    var phoneParent = sticky.querySelector('.ef-pd2-sticky__inner');
    if (phoneParent) phoneParent.insertBefore(phone, stickyAtc);
  }
  if (!atcArrow) {
    var actionContent = sticky.querySelector('.ef-pd2-sticky__atc-content') || stickyAtc;
    actionContent.insertAdjacentHTML('beforeend', '<svg class="ef-pd2-sticky__atc-arrow" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>');
    atcArrow = sticky.querySelector('.ef-pd2-sticky__atc-arrow');
  }
  function purchaseLockedLabel() {
    var text = (realAtc.textContent || '').replace(/\s+/g, ' ').trim();
    if (realAtc.getAttribute('data-ef-cta-state') === 'pending') {
      var express = document.getElementById('efOfExpressCheckout');
      var expressText = express ? (express.textContent || '').replace(/\s+/g, ' ').trim() : '';
      return /starting|processing/i.test(expressText) ? expressText : 'Adding…';
    }
    return realAtc.getAttribute('aria-busy') === 'true' || /\b(adding|added|processing|starting checkout|sold\s*out|unavailable|loading)\b/i.test(text) ? text : '';
  }


  /* ----- T6-D 2026-09-02 (ROUND-6-SPEC D9, CRO round-6 item 1) — ONE VERB -----
     The page said "Build your door" and the bar said "Add to cart" for the same
     product, which asks the buyer whether the six steps can be skipped. On a
     configurable door the bar now carries the page's verb until the buyer reaches
     the review chapter, and in that mode it CANNOT reach the cart at all: the click
     handler returns before the branch that mirrors the real ATC.
     Read-only against the wizard: cfgType comes from #efCfg's own data attribute and
     the step from the detail of ef-cfg:state-changed, which ef-configurator-v2.js
     already dispatches (:4331). Nothing here calls into the configurator except the
     two helpers it already exposed, and the page CTA it already ships.
     Scope: the DOORS wizard only (#efCfgATC). The mantel PDP mirrors #efmSubmit and
     is left exactly as it was. cfg-standard keeps "Add to cart" — there is nothing
     to build on a stocked size. */
  var isDoorsWizard = realAtc.id === 'efCfgATC';
  /* §R9-H8 — the order form is a single `['Order']` page (ef-configurator-v2.js
     :61-62), so it has no chapters, no build verb and no step count. Every
     branch below that would otherwise say "step 3 of 6" reads this flag. */
  var isOrderForm   = realAtc.id === 'efOfAtc';
  var cfgRoot       = document.getElementById('efCfg');
  var cfgTypeAttr   = cfgRoot ? (cfgRoot.getAttribute('data-cfg-type') || '') : '';
  var pageBuildCta  = document.querySelector('[data-efx-build]');
  var BUILD_LABEL   = (function () {
    /* The page CTA already server-renders the right noun ("door" / "screen"). */
    var t = pageBuildCta ? (pageBuildCta.textContent || '').replace(/\s+/g, ' ').trim() : '';
    return /^(build|order|design)\b/i.test(t) ? t : 'Build your door';
  })();
  var buildMode = false;

  function setStickyLabel(text) {
    if (!atcLabel) return;
    if (purchaseLockedLabel()) return;
    if (atcLabel.textContent !== text) atcLabel.textContent = text;
    /* keep the "Adding..." spinner's restore target in step with the live label */
    atcLabel.dataset.original = text;
  }

  /* Paint the verb before the first state event so the bar never flashes the wrong
     word on load. cfg-standard is excluded by its own attribute, not by waiting. */
  if (isDoorsWizard && cfgTypeAttr !== 'cfg-standard') {
    buildMode = true;
    setStickyLabel(BUILD_LABEL);
    stickyAtc.setAttribute('aria-label', BUILD_LABEL + ' \u2014 opens the builder');
  }

  /* In build mode the bar routes to the builder and nowhere else. If the builder is
     off screen it does exactly what the page CTA does (same anchor, same
     body.efx-building focus mode); if the buyer is already looking at it, it advances
     the chapter, which is the only way to reach the review step the label promises. */
  function activeStepNext() {
    var candidates = document.querySelectorAll('#efCfgNext, #efmNext1, #efmNext2, #efmNext3, [data-ef-step-next]');
    for (var i=0;i<candidates.length;i++) { var b=candidates[i]; if (b.getAttribute('data-ef-next-label') && b.getClientRects().length && getComputedStyle(b).display !== 'none') return b; }
    return null;
  }

  function routeToBuilder() {
    if (!isDoorsWizard) { var next = activeStepNext(); if (next) { next.click(); return; } }
    var band = document.getElementById('build');
    var inView = false;
    if (band) {
      var r = band.getBoundingClientRect();
      inView = r.top < window.innerHeight * 0.55 && r.bottom > 120;
    }
    if (!inView) {
      if (pageBuildCta) { pageBuildCta.click(); return; }
      if (band) { band.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
    }
    if (typeof window.efCfgValidateAndAdvance === 'function') { window.efCfgValidateAndAdvance(); return; }
    var target = document.querySelector('.ef-cfg-step.is-visible')
              || document.querySelector('#efCfg');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /* ----- Money formatter — mirrors theme money_format "${{amount}}" ----- */
  function money(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    var n = cents / 100;
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  /* ----- Smart Active ATC (CRO panel 10/10 vote 2026-05-06) -----
     Button is NEVER disabled. Click behavior:
       - unlocked: mirror real ATC (existing flow)
       - locked: validate current step (red outline + "Please make a selection" on
                 missing fields, scroll to first failing group) OR advance to next step.
     Uses window.efCfgValidateAndAdvance() exposed by ef-configurator-v2.js. */
  /* 2026-05-06 — Show "Adding..." spinner on sticky button while real ATC processes.
     Mirrors what efCfgATC does. Reverts when cart-drawer opens or after 3s timeout. */
  function showStickyAdding() {
    if (!atcLabel) return;
    atcLabel.dataset.original = atcLabel.dataset.original || atcLabel.textContent;
    atcLabel.innerHTML = '<span class="ef-cfg-spinner" style="vertical-align:-3px;margin-right:6px;"></span>Adding...';
    /* Hide arrow during processing */
    if (atcArrow) atcArrow.style.visibility = 'hidden';
  }
  function revertStickyAdding() {
    if (!atcLabel || purchaseLockedLabel()) return;
    if (atcLabel.dataset.original) {
      atcLabel.textContent = atcLabel.dataset.original;
    }
    if (atcArrow) atcArrow.style.visibility = '';
  }

  stickyAtc.addEventListener('click', function (e) {
    if (purchaseLockedLabel()) { e.preventDefault(); return; }
    /* T6-D: the one guard that makes the label honest. While the bar says "Build your
       door" it is structurally incapable of posting anything to the cart. */
    if (buildMode) {
      e.preventDefault();
      routeToBuilder();
      return;
    }
    if (realAtc.getAttribute('data-ef-cta-state') === 'missing') { e.preventDefault(); realAtc.click(); return; }
    var state = sticky.getAttribute('data-state');
    if (state === 'unlocked') {
      showStickyAdding();
      realAtc.click();
      /* Revert when cart drawer opens (existing event from configurator) or after 3s safety timeout */
      var revertTimer = setTimeout(revertStickyAdding, 3000);
      var onRefresh = function() {
        clearTimeout(revertTimer);
        revertStickyAdding();
        document.removeEventListener('cart:refresh', onRefresh);
      };
      document.addEventListener('cart:refresh', onRefresh);
      return;
    }
    e.preventDefault();
    /* Mirror what the in-step "Next" button does — validates current step
       (highlights missing fields red + shows "Please make a selection") OR
       advances to next step if current is valid. Same UX as Next click. */
    if (typeof window.efCfgValidateAndAdvance === 'function') {
      window.efCfgValidateAndAdvance();
      return;
    }
    /* Fallback if helper missing — soft scroll to visible configurator */
    /* §R9-H8 — `#efOfSize` and `#efOf` join the fallback list. On the order
       form none of the three wizard selectors exist and
       window.efCfgValidateAndAdvance is undefined, so a locked tap on the bar
       used to do NOTHING AT ALL: the buyer's one visible control did not
       respond, which is worse than a disabled button. It now scrolls to the
       size question the message names. */
    var target = document.querySelector('.ef-cfg-step.is-visible')
              || document.querySelector('.ef-cfg-gas-step.is-visible')
              || document.getElementById('efOfSize')
              || document.querySelector('#efCfg, #efgWrap, #efOf');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      target.classList.add('ef-pd2-highlight');
      setTimeout(function () { target.classList.remove('ef-pd2-highlight'); }, 1500);
    }
  });

  /* ----- Resize the dot row to match the real visible-step count
          (cfg-standard / cfg-simple = 2, cfg-custom and friends = 6) ----- */
  function setDotCount(n) {
    if (!dotsWrap) return;
    var existing = dotsWrap.querySelectorAll('.ef-pd2-sticky__dot');
    if (existing.length === n) return;
    dotsWrap.innerHTML = '';
    for (var i = 0; i < n; i++) {
      var d = document.createElement('span');
      d.className = 'ef-pd2-sticky__dot';
      dotsWrap.appendChild(d);
    }
  }

  /* ----- Fill dots according to displayIdx (1-based current step) ----- */
  function fillDots(displayIdx, displayTotal, state) {
    if (!dotsWrap) return;
    setDotCount(displayTotal);
    var dots = dotsWrap.querySelectorAll('.ef-pd2-sticky__dot');
    Array.prototype.forEach.call(dots, function (d, i) {
      d.classList.remove('is-filled-info', 'is-filled-success');
      if (i < displayIdx) {
        d.classList.add(state === 'unlocked' ? 'is-filled-success' : 'is-filled-info');
      }
    });
  }

  /* ----- Apply the 3 visual states based on dispatched detail -----
     locked-0   : just landed
     locked-mid : at least one step done, more to go
     unlocked   : minimum required steps done AND realAtc not disabled
  */
  var lastDetail = null;

  /* September 11: Stoll presentation reads the existing native choices only.
     Height/depth value "0" is the first valid option, never an empty choice.
     Keep pricing, unlock decisions and purchase handlers owned by the engine. */
  var isStollMantel = document.body.classList.contains('template-product-mantel-shelves') && realAtc.id === 'efmSubmit';
  var stollDimensionIds = ['efmLengthSelect', 'efmHeight', 'efmDepth'];
  function stollDimensionsComplete() {
    return isStollMantel && stollDimensionIds.every(function (id) {
      var field = document.getElementById(id);
      return field && field.value !== '';
    });
  }
  if (isStollMantel && msg) {
    var stollInner = sticky.querySelector('.ef-pd2-sticky__inner');
    if (stollInner) stollInner.appendChild(msg);
    msg.setAttribute('role', 'status');
    msg.setAttribute('aria-live', 'polite');
    msg.setAttribute('aria-atomic', 'true');
    stickyAtc.setAttribute('aria-describedby', msg.id);
  }

  function applyState(detail) {
    lastDetail = detail;
    var stollHasDimensions = stollDimensionsComplete();

    var totalSteps   = detail.totalSteps || 6;
    var totalSkipped = detail.totalSkipped || 0;
    var displayTotal = Math.max(1, totalSteps - totalSkipped);
    var stepsDone    = Math.max(0, detail.curStep || 0);
    var displayIdx   = Math.max(0, Math.min(displayTotal, stepsDone + 1));

    /* 2026-05-06 — User requires ALL selections to be made to unlock ATC.
       Replaces the prior "must be on review step" rule — sticky now unlocks
       wherever the user is currently viewing, as long as every required field
       is filled. allSelectionsMade is broadcast by the configurator (doors via
       _allSelectionsMade(), mantels via state.length+height+depth+color check). */
    var minToUnlock = (detail.cfgType === 'cfg-standard' || detail.cfgType === 'cfg-simple')
      ? 1
      : displayTotal;

    var realDisabled = !!realAtc.disabled;
    var canUnlock    = !realDisabled && (
      detail.allSelectionsMade === true ||
      stepsDone >= minToUnlock
    );

    var stateName;
    if (canUnlock) {
      stateName = 'unlocked';
    } else if (stepsDone >= 1) {
      stateName = 'locked-mid';
    } else {
      stateName = 'locked-0';
    }

    sticky.setAttribute('data-state', stateName);
    /* 2026-05-06 — button NEVER disabled (CRO panel consensus). Click in locked
       state scrolls to next step instead of dead-end. */
    stickyAtc.disabled = false;
    stickyAtc.removeAttribute('aria-disabled');

    /* Always show arrow, never lock — active button visual */
    if (atcLock)  atcLock.style.display  = 'none';
    if (atcArrow) atcArrow.style.display = '';

    /* Liquid-fill progress — bronze fills left→right as steps complete.
       Sets CSS variable + aria-valuenow for screen readers. 2026-05-06. */
    var fillPct = displayTotal > 0
      ? Math.min(100, Math.round((stepsDone / displayTotal) * 100))
      : 0;
    if (stateName === 'unlocked') fillPct = 100;
    stickyAtc.style.setProperty('--efp-fill', fillPct + '%');
    stickyAtc.setAttribute('aria-valuenow', String(stepsDone));
    stickyAtc.setAttribute('aria-valuemax', String(displayTotal));
    /* §R9-H8 — "0 of 1 steps complete" is not a sentence worth reading out.
       On the order form the button is a button. */
    if (isOrderForm) {
      stickyAtc.setAttribute('aria-label', stateName === 'unlocked'
        ? 'Add to cart'
        : 'Pick your opening size to continue');
    } else {
      stickyAtc.setAttribute('aria-label',
        stateName === 'unlocked'
          ? 'Add to cart — all ' + displayTotal + ' steps complete'
          : 'Add to cart — ' + stepsDone + ' of ' + displayTotal + ' steps complete'
      );
    }

    /* Progress message — 3-tier copy per user spec 2026-05-03:
       LOCKED → "Add measurements to enable checkout"
       UNLOCKED MID → "You can checkout now · or customize further"
       FULLY COMPLETE → "Ready to checkout · All steps complete"
       isLast = true when on the final review step (all decisions made). */
    if (msg) {
      /* 2026-05-06 — "fully complete" now means all selections made (allSelectionsMade)
         OR navigated to review (isLast). Either path shows the ready-to-checkout copy. */
      var fullyComplete = (stateName === 'unlocked') &&
                          (detail.allSelectionsMade === true || detail.isLast);
      if (fullyComplete) {
        msg.textContent = isOrderForm
          ? 'Ready — add to cart'
          : '✓ Ready to checkout · All steps complete';
      } else if (stateName === 'unlocked') {
        msg.textContent = isOrderForm
          ? 'Ready — add to cart'
          : '✓ You can checkout now · or customize further';
      } else {
        msg.textContent = isStollMantel
          ? (stollHasDimensions ? 'Choose a finish.' : 'Choose dimensions.')
          : isOrderForm
          /* §R9-H8 — nobody measures anything on this flow: the sizes are ranges
             and the buyer picks one. The doors wizard's verb was wrong here. */
          ? 'Pick your opening size to continue'
          : 'Add measurements to enable checkout';
      }
    }

    /* Price label + From toggle */
    if (priceAmount && typeof detail.totalCents === 'number') {
      priceAmount.textContent = money(detail.totalCents);
    }
    if (stateName === 'unlocked' || stollHasDimensions) {
      if (priceFrom)  priceFrom.style.display  = 'none';
      if (priceLabel) priceLabel.textContent   = 'Your configuration';
    } else {
      if (priceFrom)  priceFrom.style.display  = '';
      if (priceLabel) priceLabel.textContent   = 'Starting at';
    }

    /* 2026-05-06 — Option B: keep static "Add to cart" label always.
       Active button + scroll-to-step on click handles incomplete state without
       dynamic copy. User chose simpler pattern over dynamic-copy variant.
       T6-D 2026-09-02 (D9): still one label per state, but the state that decides it
       is the CHAPTER, not the unlock. detail.isLast is the wizard's own review flag
       (ef-configurator-v2.js:4336, idx === totalSteps - 1). */
    var nextAction = activeStepNext();
    var actionLabel = nextAction ? nextAction.getAttribute('data-ef-next-label') : realAtc.getAttribute('data-ef-next-label');
    buildMode = (isDoorsWizard
             && detail.cfgType !== 'cfg-standard'
             && detail.isLast !== true) || !!nextAction;
    if (buildMode) {
      setStickyLabel(actionLabel || BUILD_LABEL);
      stickyAtc.setAttribute('aria-label', actionLabel || BUILD_LABEL);
    } else {
      setStickyLabel(actionLabel || 'Add to cart');
      if (actionLabel) stickyAtc.setAttribute('aria-label', actionLabel);
    }
    var lockedLabel = purchaseLockedLabel();
    if (lockedLabel) {
      if (atcLabel) atcLabel.textContent = lockedLabel;
      stickyAtc.disabled = true;
      stickyAtc.setAttribute('aria-disabled', 'true');
      stickyAtc.setAttribute('aria-label', lockedLabel);
    }

    if (atcArrow) atcArrow.style.visibility = lockedLabel ? 'hidden' : '';
    fillDots(displayIdx, displayTotal, stateName);
  }

  /* ----- Listeners ----- */
  new MutationObserver(function() { if (lastDetail) applyState(lastDetail); }).observe(realAtc, {childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-busy','data-ef-next-label','data-ef-cta-state']});
  window.addEventListener('ef-cfg:cta-changed', function() {
    if (lastDetail) applyState(lastDetail);
  });
  window.addEventListener('ef-cfg:state-changed', function (e) {
    if (e && e.detail) applyState(e.detail);
  });

  window.addEventListener('ef-cfg:price-changed', function (e) {
    if (!e || !e.detail) return;
    if (typeof e.detail.totalCents === 'number') {
      if (priceAmount) priceAmount.textContent = money(e.detail.totalCents);
      /* atcLabel kept as "Add to cart" — price suffix removed (redundant w/ priceAmount on same bar). */
    }
    /* Re-evaluate state in case a selection just enabled the real ATC
       (e.g. user picked a size on a cfg-standard product).
       2026-05-06 — also pull through allSelectionsMade so the sticky unlocks
       on selection changes that happen WITHIN a step (no goToStep dispatch). */
    if (lastDetail) {
      lastDetail.totalCents = e.detail.totalCents;
      if (typeof e.detail.allSelectionsMade === 'boolean') {
        lastDetail.allSelectionsMade = e.detail.allSelectionsMade;
      }
      applyState(lastDetail);
    }
  });

  if (isStollMantel) {
    document.addEventListener('change', function (event) {
      if (event.target && stollDimensionIds.indexOf(event.target.id) !== -1 && lastDetail) applyState(lastDetail);
    });
    applyState(lastDetail || { cfgType: 'cfg-mantels', curStep: 0, totalSteps: 4 });
  }

  /* ----- Safety net: poll #efCfgATC.disabled briefly so unlock state syncs
          even if a selection-change happens without an event. Self-terminates
          after 30s — cheap and defensive. ----- */
  var lastDisabled = realAtc.disabled;
  var pollCount = 0;
  var pollId = setInterval(function () {
    pollCount++;
    if (realAtc.disabled !== lastDisabled) {
      lastDisabled = realAtc.disabled;
      if (lastDetail) applyState(lastDetail);
    }
    if (pollCount > 60) clearInterval(pollId); // 30s
  }, 500);
})();
